import { type PaginationParams } from '@webapp/core/providers/Pagination/pagination.types'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { auditLogRepository } from '../data-access/repositories'

const base = ['audit-log']

export const auditLogQueryConfig = {
  getAuditLog: (params?: {
    contentTypeId?: number
    objectId: string
    paginationParams?: PaginationParams
  }) => {
    const { contentTypeId, objectId, paginationParams } = params || {}

    return {
      queryKey: buildQueryKey([
        ...base,
        contentTypeId,
        objectId,
        paginationParams,
      ]),
      queryFn: () => {
        if (contentTypeId === undefined || objectId === undefined) {
          throw new Error(
            'Missing required parameters for getAuditLog query. Ensure contentTypeId and objectId are defined.'
          )
        }

        return auditLogRepository.getAuditLog(
          contentTypeId,
          objectId,
          paginationParams
        )
      },
    }
  },
}
